import { CartItem } from "../utils/interfaces";
import usePosOrderDeliveryMethod from "../atoms/usePosOrderDeliveryMethodAtom";

const usePosMenuGetVatHook = () => {
  const [deliveryMethod] = usePosOrderDeliveryMethod();

  return (product: CartItem) => {
    return product.vat_percentage_per_target
      ? product.vat_percentage_per_target[deliveryMethod] ??
          product.vat_percentage
      : product.vat_percentage;
  };
};

export default usePosMenuGetVatHook;
